import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AsyncPipe, CommonModule, NgClass, NgIf } from '@angular/common';
import { Observable } from 'rxjs';
import { PlanDetails } from '@self-fix/data-access';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { IconComponent } from '@domgen/dgx-fe-components/icon';

@Component({
  selector: 'plan-banner',
  standalone: true,
  imports: [
    AsyncPipe,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgClass,
    NgIf,
    CommonModule,
    IconComponent,
  ],
  templateUrl: './plan-banner.component.html',
  styleUrls: ['./plan-banner.component.scss'],
})
export class PlanBannerComponent {
  @Input() activePlan$: Observable<PlanDetails>;
  @Output() togglePlanSelection = new EventEmitter<void>();
}
